import React from 'react';
import { Tag } from '../components/Styled';
import Toast from '../components/Toast';

const Comments = ['폐업', '퇴사', '효과미비', '상품변경', '고객요청', '기타'];

function getHistoryType(type) {
  switch (type) {
    case 0: return <Tag color="blue">수정</Tag>
    case 1: return <Tag color="red">취소</Tag>
    case 2: return <Tag color="purple">환불</Tag>
    case 3: return <Tag color="green">복구</Tag>
    case 4: return <Tag color="gray">종료</Tag>
    default: return <Tag color="gray">알수없음</Tag>
  }
}

export default {
  Comments,
  getHistoryType
}


// WEBPACK FOOTER //
// ./client/utils/payments.js